import React from 'react';
import { connect } from 'react-redux';
import * as actTableManagement from 'actions/tableManagement/voidItem';
import ConfirmActionModal from 'components/ConfirmActionModal';
import {
  ContentWrapper,
  LeftColumnWrapper,
  RightColumnWrapper,
  PageWrapper,
} from 'components/wrappers/pages';
import NoDataAndLoading from 'components/NoDataAndLoading';
import './TableManagementVoidItemReport.css';
import ReportDetail from '../TableManagementReport/ReportDetail';
import List from './List';
import ActionBar from './ActionBar';

class TableManagementVoidItemReport extends React.Component {
  componentDidMount() {
    this.props.dispatch(actTableManagement.voidItemReportPageRequest());
  }

  render() {
    const { reports, showLoadingSpinnerPage } = this.props;
    return (
      <PageWrapper>
        <ActionBar location={this.props.location} />
        <ContentWrapper>
          <LeftColumnWrapper>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={reports.length === 0}
              title="No data to display"
              description=""
            />
            {!showLoadingSpinnerPage && <List />}
          </LeftColumnWrapper>
          <RightColumnWrapper>
            <ReportDetail />
          </RightColumnWrapper>
        </ContentWrapper>
        <ConfirmActionModal />
      </PageWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    reports: state.tableManagement.voidItem.reports,
    showLoadingSpinnerPage: state.loadingSpinner.showLoadingSpinnerPage,
    nextAction: state.confirmAction.nextAction,
  };
}

export default connect(mapStateToProps)(TableManagementVoidItemReport);
